import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import useFilterItemsWithAmount from '../../../hooks/useFilterItemsWithAmount';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import useRequestStatuses from '../../../../../queries/useRequestStatuses';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import { statisticsPages } from '../../../../../constants/statisticsPages';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';

const statusOrderByName = [
  'Новая',
  'В работе',
  'Выполнена',
  'Выполнена(контроль качества)',
  'Закрыта',
  'Аннулирована',
];

const statusNew = {
  id: 1,
  orderNum: 1,
  name: 'New',
  description: 'Новая',
};

const filter = filtersData[filterNames.statuses];

const StatusesFilter = ({ disabled = false }) => {
  const params = useParams();

  const [filterState, setFilterState] = useFilterState(filter);

  const { data, isFetching } = useRequestStatuses({ staleTime: Infinity });

  const { items, itemsMap } = useFilterItemsWithAmount({
    data,
    requestKey: 'statusId',
    customSort: true,
    customSortFn: (a, b) =>
      statusOrderByName.indexOf(a.description) -
      statusOrderByName.indexOf(b.description),
  });

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);

    setFilterState(newState);
  };

  const hasFilter = filterState.length > 0;
  const allSelected = hasFilter && itemsMap.size === filterState.length;
  const isActivePage = params.page === statisticsPages.active;

  useEffect(() => {
    if (filterState.length && items.length) {
      const newFilter = filterState.filter((filterId) =>
        items.some((item) => item.id === filterId)
      );

      setFilterState(newFilter);
    }
  }, [items, filterState]);

  const filteredItems = items.filter((item) => filterState.includes(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      {isActivePage && (
        <>
          <FilterButton
            text="Статус"
            selected
            withArrow={false}
            style={{ pointerEvents: 'none' }}
          />
          <SelectedOption
            text={statusNew.description}
            value={statusNew.id}
          />
        </>
      )}
      {!isActivePage && (
        <>
          <FilterDropdown
            disabled={isFetching || disabled}
            filter={filter}
            items={items}
            getItemContent={(item) => item.description}
            getSearchContent={(item) => item.description}
            renderButton={({ visible }) => (
              <FilterButton
                text="Статус"
                opened={visible}
                selected={hasFilter}
              />
            )}
          />
          {allSelected && (
            <SelectedOption
              text="Все"
              onRemove={() => setFilterState([])}
            />
          )}
          {!allSelected && (
            <>
              {visibleItems.map((item) => (
                <SelectedOption
                  key={item.id}
                  text={item.description}
                  value={item.id}
                  onRemove={handleItemRemove}
                />
              ))}
              {Array.isArray(hiddenItems) && !!hiddenItems.length && (
                <HiddenSelectedOptions
                  hiddenItems={hiddenItems}
                  handleItemRemove={handleItemRemove}
                />
              )}
            </>
          )}
        </>
      )}
    </FilterContainer>
  );
};

export default StatusesFilter;
